import { _log, isMobileDevice, getGSAP } from '../common/js/lib/utils.js';
import MainVisualMovie from './_mainVisualMovie.js';
import GuidanceCont from './_guidanceCont.js';
import UspArea from './_uspArea';

export default class TopPage {
  constructor() {
    this.isMobile = isMobileDevice();
    this.init();
  }

  init() {
    _log('PAGE', 'Top page initialized', '#2563eb');
    this.mainVisualMovie = new MainVisualMovie();
    this.guidanceCont = new GuidanceCont();
    this.UspArea = new UspArea();
  }

  /**
   * ScrollTriggerを動的にインポートしてrefreshを実行（PCのみ）
   */
  async refreshScrollTrigger() {
    if (this.isMobile) return;

    try {
      const { ScrollTrigger } = await getGSAP();
      ScrollTrigger.refresh();
    } catch (error) {
      console.warn('[TopPage] Failed to refresh ScrollTrigger:', error);
    }
  }
}
